export type Grupo = {
  GroupId?: string
  Name?: string
}

export type Local = {
  CodLocal?: string
  CodigoInterno?: string
  Nome?: string
  Descricao?: string
  Endereco?: string
  Cidade?: string
  Estado?: string
  Latitude?: number
  Longitude?: number
  Ativo?: boolean
  Setores?: Setor[]
}

export type Setor = {
  CodLocal?: string
  CodSetor?: string
  CodigoInterno?: string
  Nome?: string
  Descricao?: string
  Ativo?: boolean
}

export type Profissional = {
  Name?: string
  Email?: string
  Phone?: string
  Phone1?: string
  ProfessionalId?: string
  ProfessionalIdUF?: string
  Address?: string
  Address2?: string
  AddressNumber?: number
  Town?: string
  Zipcode?: string
  City?: string
  State?: string
  UserType?: string
  InternalCode?: string
  MoreDetails?: string
  CompanyName?: string
  CompanyTradeName?: string
  CNPJ?: string
  CPF?: string
  AdmissionDate?: string
}

export type DadosContato = {
  CodUf?: number
  Telefone?: string
  Celular?: string
  Cep?: string
  Rua?: string
  Numero?: number
  Complemento?: string
  CodCidade?: number
  Bairro?: string
}

export type ProfissionalCompleto = {
  Email?: string
  CodigoProfissao?: string
  CodUfConselhoProfissional?: number
  RegistroConselhoProfissional?: string
  NomeCompleto?: string
  DataAdmissao?: string
  CodProfissional?: string
  DadosContato?: DadosContato
  EnviarConvite?: boolean
  Detalhes?: string
  CodInterno?: string
  CPF?: string
  RQE?: string
  Grupos?: string[]
}

export type ProfissionalSituacao = {
  NomeProfissional?: string
  CodProfissional?: string
  CodSituacao?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 97 | 98 | 99
  Situacao?: string
  HorarioPlantao?: string
  HorarioFimPlantao?: string
}

type DiaSemana = 1 | 2 | 3 | 4 | 5 | 6 | 7 // Domingo a sábado

export type FiltroPlantao = {
  dataInicio?: string //yyyy-MM-dd
  dataFim?: string
  horaInicio?: string // HH:mm:ss
  horaFim?: string
  codTipoPlantao?: string
  codSetores?: string[]
  codGrupos?: string[]
  diasSemana?: DiaSemana[]
  exibirApenasFuros?: boolean
  exibirPlantoesVazios?: boolean
  exibirApenasPlantoesAnunciados?: boolean
  exibirPlantoesQueNaoNecessitamDeCobertura?: boolean
}

export type Plantao = {
  Local?: string
  CodigoLocal?: string
  Setor?: string
  CodigoSetor?: string
  Inicio?: string
  Fim?: string
  Tipo?: string
  Valor?: number
  ProfFixo?: string
  CpfProfFixo?: string
  CodigoProfFixo?: string
  ProfFixoStatus?: string
  ProfDePlantao?: string
  CpfProfDePlantao?: string
  CodigoProfDePlantao?: string
  CodigoPlantao?: string
  Descricao?: string
  Anunciado?: boolean
  ComentarioInterno?: string
  RegistroEntrada?: string
  RegistroSaida?: string
  DataCriacao?: string
  Produtividades?: string[]
  Quantidade?: number
}

export type TipoPlantao = {
  TipoPlantaoId?: string
  Nome?: string
  Cor?: string
}

export interface QueryStatePlantao {
  inicio?: string
  termino?: string
  local?: string
  setor?: string
  tipoPlantao?: string
}

export type QueryRequestContextPropsPlantao = {
  state: QueryStatePlantao
  updateState: (updates: Partial<QueryStatePlantao>) => void
}

export const initialQueryRequestEscala: QueryRequestContextPropsPlantao = {
  state: {},
  updateState: () => {},
}

export type ExportaSlotsDto = {
  idEmpresa: number
  idEspecialidade: number
  data: string
  horarioInicio: string
  horarioTermino: string
}
